import React from 'react';

const buttonHolderStyles = {
  position: 'absolute',
  bottom: '0',
  left: '50%',
  transform: 'translateX(-50%)',
  clear: 'both',
}

const LandingPage = (props) => {
  const styles = {
    background: `url(${props.bgImg})`,
    position: 'relative',
    maxHeight: '722px',
    minHeight: '600px',
    maxWidth: '320px',
    height: '80vh',
    width: '80vw',
    backgroundSize: 'cover',
    margin: '0 auto',
  }
  return (
    <div style={styles}>
      { props.children }
      <div style={buttonHolderStyles}>
        <a href="../signin" className="navLogIn">LOG IN</a>
      </div>
    </div>
  );
}


export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/Landing/index.js